// Puerto de packages/hce/src/hce/useEspecialidadesHabilitadas.ts — único
// cambio real: useMedplum viene de @medplum/react-hooks (paquete de solo
// hooks, sin Mantine) en vez de @medplum/react (hce-react).
import { useMedplum } from '@medplum/react-hooks';
import { useEffect, useState } from 'react';

const EXT_URL = 'http://logiacare.ec/fhir/especialidades-habilitadas';

export type EstadoEspecialidades = { cargando: true } | { cargando: false; codigos: string[] };

export function useEspecialidadesHabilitadas(): EstadoEspecialidades {
  const medplum = useMedplum();
  const [codigos, setCodigos] = useState<string[]>();

  useEffect(() => {
    let cancelado = false;
    medplum
      .searchOne('Organization', {})
      .then((org) => {
        if (cancelado) return;
        const ext = org?.extension?.find((e) => e.url === EXT_URL);
        const valores = (ext?.extension ?? []).map((e) => e.valueCode).filter((v): v is string => !!v);
        setCodigos(valores);
      })
      .catch(() => {
        if (!cancelado) setCodigos([]);
      });
    return () => {
      cancelado = true;
    };
  }, [medplum]);

  if (codigos === undefined) {
    return { cargando: true };
  }
  return { cargando: false, codigos };
}

export function estaHabilitado(codigo: string, codigosHabilitados: string[]): boolean {
  return codigosHabilitados.includes(codigo);
}
